function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconStairsDownActive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 9,
    style: {
      fill: "#6cd46c",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10,0C4.49,0,0,4.49,0,10s4.49,10,10,10,10-4.48,10-10S15.51,0,10,0Zm0,19c-4.96,0-9-4.03-9-9S5.04,1,10,1s9,4.04,9,9-4.04,9-9,9Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.37,6.67v2.47h2.74v2.47h2.74v2.47h2.1v1.27h-3.37v-2.47h-2.74v-2.47h-2.74v-2.47h-2.1v-1.27h3.37Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.08,6v3c0,.07-.01.12-.03.17-.03.06-.06.11-.11.16-.04.04-.09.07-.15.1-.05.02-.11.03-.17.03h-3c-.25,0-.46-.2-.46-.46s.21-.46.46-.46h1.89l-2.55-2.55c-.08-.08-.13-.2-.13-.32s.05-.24.13-.32c.18-.18.48-.18.65,0l2.55,2.55v-1.9c0-.25.21-.46.46-.46s.46.21.46.46Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStairsDownActive);
export default __webpack_public_path__ + "static/media/icon-stairs-down-active.c50f0c883abf9288199de1d272c2fdaa.svg";
export { ForwardRef as ReactComponent };